import { createI18nText } from '@hilma/netina2all';

const personalDetailsText = createI18nText({
	he: {
		fullName: 'שם מלא',
		address: 'כתובת מלאה (עיר, רחוב, מספר בית)',
		phone: 'טלפון נייד',
		confirmPhone: 'אימות טלפון נייד',
		email: 'מייל',
		confirmEmail: 'אימות מייל',
		code: 'קןד אימות',
		phoneExists: 'המידע שהזנת כבר קיים במערכת. תצטרך לאמת את מספר הטלפון',
		verify: 'אימות',
		codeSent1: 'נשלח קוד למספר הטלפון',
		codeSent2: 'הכנס את הקוד על מנת לאמת את מספר הטלפון:',
		cancel: 'ביטול',
		none: '',
		overwriteD: 'אנו נפנה אליך מעתה במייל ומספר הטלפון שהזנת. האם זה בסדר?',
		yes: 'אישור',
		errors: {
			UserIsBlocked: 'מספר הטלפון נחסם',
			MaxAttempts: 'הגעת למספר המקסימלי של נסיונות',
			CodeHasExpired: 'קוד האימות כבר לא תקף',
			IncorrectCode: 'קוד האימות אינו תקין',
			NoUsername: 'מספר הטלפון לא נמצא במערכת',
		}
	},
	en: {
		fullName: 'Full Name',
		address: 'Full Address (City/ District, Street, House Number)',
		phone: 'Phone Number',
		confirmPhone: 'Confirm Phone Number',
		email: 'Email Address',
		confirmEmail: 'Confirm Email Address',
		code: 'code',
		phoneExists: 'The information you entered already exists in the system. You will need to verify your phone number',
		verify: 'Verify',
		codeSent1: 'A code was sent to the phone number',
		codeSent2: 'Enter the code to verify the phone number:',
		cancel: 'Cancel',
		none: '',
		overwriteD: 'We will conatact you with the email and the phone number you entered. Is that ok?',
		yes: 'Yes',
		errors: {
			UserIsBlocked: 'The phone number has been blocked',
			MaxAttempts: 'You have reached the max number of attempts',
			CodeHasExpired: 'The code has expired',
			IncorrectCode: 'The code is incorrect',
			NoUsername: "The phone number doesn't exist in the system"
		}
	}
});

export default personalDetailsText;